// extracted by mini-css-extract-plugin
export default {"menuBlock":"BI-z","title":"CI-z","nav":"DI-z","flexCell":"EI-z","facetLink":"FI-z"};